import { NgModule } from '@angular/core';
import { NavvisApiService } from '../services/navvis-api.service';
import { provideNavVisConfiguration } from './navvis-api-configuration';

@NgModule({
  declarations: [],
  providers: [provideNavVisConfiguration(), NavvisApiService],
})
export class NavvisApiModule {}
